import React from "react";

function About() {
  return (
    <section id="about" className="py-24 px-6">
      <div className="fade-section max-w-3xl mx-auto">
        <h2 className="text-sm font-medium text-accent uppercase tracking-widest mb-4">
          About
        </h2>
        <h3 className="text-3xl md:text-4xl font-bold text-white mb-8">
          A bit about me
        </h3>
        <div className="space-y-4 text-neutral-400 leading-relaxed">
          <p>
            I'm a software developer from{" "}
            <span className="text-white">Uppsala, Sweden</span>. I fell in love
            with programming and have been building things ever since.
          </p>
          <p>
            My main focus is{" "}
            <span className="text-white">image processing</span> and{" "}
            <span className="text-white">Python</span> — working with computer
            vision, data pipelines, and building tools that make sense of visual
            data. I enjoy writing clean, modular code that solves real problems.
          </p>
          <p>
            On the side I also dabble in{" "}
            <span className="text-white">web</span> and{" "}
            <span className="text-white">mobile development</span>, mostly as a
            way to build interfaces around the things I work on.
          </p>
          <p>
            When I'm not coding, you'll find me playing games, on the volleyball
            court, or travelling somewhere new.
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;
